import { withI18n } from 'panda-i18n';
import locale from "../../locales";
import { CardItems } from './card-items';
import './index.scss';
export var CnCardItems = withI18n(CardItems, { locale: locale });
